
const digest = '3f6d143289f858940583a55846dcbcd17051d3e6e1e5cdfea24f54e0d8eb3d12';
const classes = {"wrapper":"_wrapper_6sfux_1","content":"_content_6sfux_4","text":"_text_6sfux_12","note":"_note_6sfux_17","controls":"_controls_6sfux_22"};
const css = `._wrapper_6sfux_1 {
  font-family: Rubik, "sans-serif";
}
._wrapper_6sfux_1 ._content_6sfux_4 {
  background-color: #eaedf3;
  margin: -34px -24px 24px -24px;
  padding: 30px 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_6sfux_1 ._content_6sfux_4 ._text_6sfux_12 {
  color: #000000;
  font-weight: 400;
  font-size: 18px;
}
._wrapper_6sfux_1 ._content_6sfux_4 ._note_6sfux_17 {
  color: #767b84;
  font-weight: 400;
  font-size: 14px;
}
._wrapper_6sfux_1 ._controls_6sfux_22 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  